import { render, staticRenderFns } from "./NonGeoPicklStats.vue?vue&type=template&id=c2a2a788&scoped=true&"
import script from "./NonGeoPicklStats.vue?vue&type=script&lang=js&"
export * from "./NonGeoPicklStats.vue?vue&type=script&lang=js&"
import style0 from "./NonGeoPicklStats.vue?vue&type=style&index=0&id=c2a2a788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a2a788",
  null
  
)

export default component.exports